import { render } from "./KnowhowTip2.vue?vue&type=template&id=69ac1957"
import script from "./KnowhowTip2.vue?vue&type=script&lang=js"
export * from "./KnowhowTip2.vue?vue&type=script&lang=js"

import "./KnowhowTip2.vue?vue&type=style&index=0&id=69ac1957&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__